import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EmptyState, Ico, Btn } from "@kit-v5";
import { logout } from "../api/auth";
import { useAuthStore } from "../state/authStore";
import { useT } from "../i18n/i18n";
import "./MustChangePassword.css";
export default function MustChangePassword() {
    const t = useT();
    const clearAuth = useAuthStore((s) => s.clear);
    async function handleLogout() {
        try {
            await logout();
        }
        catch { /* всё равно выходим локально */ }
        clearAuth();
        window.location.assign("/login");
    }
    return (_jsx("div", { className: "core-login", children: _jsxs("div", { className: "core-login-card", children: [_jsx(EmptyState, { icon: Ico.key, title: t("auth.must_change.title"), description: t("auth.must_change.description") }), _jsx(Btn, { kind: "secondary", onClick: handleLogout, children: t("auth.common.logout") })] }) }));
}
